import React from 'react';
import './App.css';
import LogoAnimation from './LogoAnimation';

function App() {
  return (
    <div className="App">
      <LogoAnimation />
      {/* Add footer text */}
      <footer className="footer">2025 Heliqon LLC</footer>
    </div>
  );
}

export default App;
